// Brands allowed to be created
export const ALLOWEDBRANDS = ['GDY', 'BGT', 'HKK', 'PRL', 'NEX']
